module.exports = __webpack_public_path__ + "img/lunas_rabbit_petronas.7dee7ef0.jpg";